/**
 * ClinicalImpression Facade
 *
 * Stable API surface for clinical impression operations.
 * Aggregates actions for presentation layer consumption.
 * @agentic connections
 */

import type { MedplumClient } from "@medplum/core";
import type { ClinicalImpression } from "@medplum/fhirtypes";
import {
  upsertClinicalImpression,
  type UpsertClinicalImpressionInput,
} from "@benchmark/core/actions";

/**
 * Creates a ClinicalImpression facade instance bound to a MedplumClient.
 * @agentic connections
 */
export function createClinicalImpressionFacade(medplum: MedplumClient) {
  return {
    /**
     * Create, update, or delete a clinical impression.
     * @agentic connections
     */
    upsert: (
      input: UpsertClinicalImpressionInput,
    ): Promise<ClinicalImpression | undefined> => {
      return upsertClinicalImpression(medplum, input);
    },
  };
}
